let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1WWCk")).then(() => parcelRequire('lQ21i'));